import { Controller } from 'react-hook-form';
import { UserIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { FormSectionV2, PersonaTextField, PersonaTextareaField } from '../../PersonaFormSectionsV2';
import { isFieldRequired } from '../EditPersonaForm.schema';
import { useEditPersonaFormContext } from '../hooks/useEditPersonaFormContext';

export function BasicInformationSectionV2() {
  const { t } = useTranslation('audiences');
  const { control } = useEditPersonaFormContext();

  return (
    <FormSectionV2
      icon={<UserIcon className="size-5" />}
      title={t('audiences.basicInformationSection.basicInformation')}
    >
      <div className="grid grid-cols-2 gap-sm">
        <Controller
          name="personaTitle"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <PersonaTextField
              {...field}
              value={field.value ?? ''}
              label={t('audiences.basicInformationSection.title')}
              placeholder={t('audiences.basicInformationSection.eGBudgetSavvyStudent')}
              required={isFieldRequired(field.name)}
              error={error?.message}
            />
          )}
        />
        <Controller
          name="segment"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <PersonaTextField
              {...field}
              label={t('audiences.basicInformationSection.segment')}
              placeholder={t('audiences.basicInformationSection.eGEcoTechAspirers')}
              required={isFieldRequired(field.name)}
              error={error?.message}
            />
          )}
        />
      </div>

      <Controller
        name="quote"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <PersonaTextareaField
            {...field}
            label={t('audiences.basicInformationSection.quote')}
            placeholder={t('audiences.basicInformationSection.iWantProductsThatMatch')}
            rows={3}
            required={isFieldRequired(field.name)}
            error={error?.message}
          />
        )}
      />
    </FormSectionV2>
  );
}

BasicInformationSectionV2.displayName = 'BasicInformationSectionV2';
